import { render } from "./UprotectChart.vue?vue&type=template&id=6d843b14&scoped=true"
import script from "./UprotectChart.vue?vue&type=script&lang=js"
export * from "./UprotectChart.vue?vue&type=script&lang=js"

import "./UprotectChart.vue?vue&type=style&index=0&id=6d843b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d843b14"]])

export default __exports__